module.exports = __webpack_public_path__ + "img/warning-icon.2492bdbb.svg";